/* eslint-disable import/prefer-default-export */
const reduceByKey = (prev, curr) => ({
  ...prev,
  [curr]: curr,
});

// Useful to reduce classes by key to avoid fake failures in snapshot testing due to dynamic classnames
export const reduceClasses = classes => Object.keys(classes).reduce(reduceByKey, {});
